import RightArrow from '../../../assets/images/left-arrow-symbol.svg';
import { useHistory } from 'react-router-dom';

type props = {
  memberName?: string | null;
  clientName?: string | null;
};

const HeadBack: React.FunctionComponent<props> = ({ memberName, clientName }) => {
  const history = useHistory();
  return (
    <div className="flex w-full">
      <div
        className="mr-4 flex justify-end rounded-full bg-white"
        role="button"
        onClick={() => {
          history.goBack();
        }}
      >
        <img className="h-8 w-8" src={RightArrow} alt="left Arrow"></img>
      </div>
      <p className="flex items-center">{memberName || clientName}</p>
    </div>
  );
};

export default HeadBack;
